import { render, staticRenderFns } from "./ImageManager.vue?vue&type=template&id=22f54975&"
import script from "./ImageManager.vue?vue&type=script&lang=js&"
export * from "./ImageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports